import {getTimestampCorrelationId} from '../canvas-timeline/canvas_timeline_performance_track';
import {fetchDataPromises} from '../scheduling_fetch';
import DirectApi from '../../../directApi';
import {getFetchDates} from '../loading/LoadMoreUtil';
import {useItemsLazyLoading} from '../canvas-timeline/canvas_timeline_util';

export const fetchData = (pageComponent, loadAllData) => {
	const req = {method: 'POST'};

	let requestUrl = DirectApi.graphqlServerEndpoint('scheduling/people/full');
	requestUrl += `?timestampCorrelationId=${getTimestampCorrelationId()}`;
	if (loadAllData) {
		requestUrl += '&loadAllData=true';
	}

	req.url = requestUrl;

	const requestUrls = [req];

	if (useItemsLazyLoading(pageComponent)) {
		req.body = {
			...getFetchDates(pageComponent),
		};
	}

	return fetchDataPromises(requestUrls);
};
